export default __webpack_public_path__ + "static/media/FunnelSimple.a6501591.svg";